<template>
  <div>
    <table>
      <thead v-if="!isMobile">
        <th></th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'r.ID'}"
          @click="sort('r.ID')">
          ID
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'r.ID'"></i>
        </th>
        <th>STATUS</th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'cb.pickupTime'}"
          @click="sort('cb.pickupTime')">
          PICKUP TIME
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'cb.pickupTime'"></i>
        </th>
        <th>DROPOFF</th>
        <th class="un-btt">FLIGHT</th>
        <th>ADA</th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'cb.passengers'}"
          @click="sort('cb.passengers')">
          PAX
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'cb.passengers'"></i>
        </th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'cb.luggage'}"
          @click="sort('cb.luggage')">
          LUGGAGE
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'cb.luggage'"></i>
        </th>
      </thead>
      <tbody>
        <unrouted-reservations-row v-for="(rsvp, index) in items" :rsvp="addMapOnlyData(rsvp)" :key="index" :isMobile="isMobile"></unrouted-reservations-row>
      </tbody>
    </table>
  </div>
</template>

<script>
import ApiLaxitReservations from '@/modules/api/laxit/reservations'
import UnroutedReservationsRow from './UnroutedReservationsRow'

export default {
  name: 'unrouted-reservations',
  components: { UnroutedReservationsRow },
  props: ['isMobile'],
  data () {
    return {
    }
  },
  computed: {
    loading () { return this.$store.state.laxit.unroutedReservations.isLoading },
    currentOrder () {
      let laxit = this.$store.state.laxit.unroutedReservations
      return { field: laxit.order, asc: laxit.orderAsc }
    },
    items () { return this.$store.state.laxit.unroutedReservations.list },
    checkedPackages () { return this.$store.state.laxit.unroutedReservations.checked },
    inMap () {
      let self = this
      let mapItems = self.$store.state.laxit.dropzone.items
      let item = mapItems.filter(mapItem => mapItem.packageID === self.opPackage.id)
      return item.length > 0
    },
    isLastPage () {
      let unroutedReservations = this.$store.state.laxit.unroutedReservations
      return (unroutedReservations.currentPage * unroutedReservations.perPage) >= unroutedReservations.maxList
    }
  },
  methods: {
    getList () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('laxit/setUnroutedReservationsIsLoading', true)
      ApiLaxitReservations.getUnrouted(self, res => {
        self.$store.commit('laxit/setUnroutedReservationsIsLoading', false)
      })
    },
    sort (field) {
      if (this.loading) { return }
      let laxit = this.$store.state.laxit.unroutedReservations
      if (field !== laxit.order) {
        this.$store.commit('laxit/setUnroutedReservationsOrderAsc', 1)
      } else {
        this.$store.commit('laxit/setUnroutedReservationsOrderAsc', laxit.orderAsc === 1 ? 0 : 1)
      }
      this.$store.commit('laxit/setUnroutedReservationsOrder', field)
      this.$store.commit('laxit/setUnroutedReservationsCurrentPage', 1)
      this.$store.commit('laxit/resetUnroutedReservationsList')
      this.getList()
    },
    loadMore () {
      if (this.isLastPage || this.loading) { return }
      this.$store.commit('laxit/setUnroutedReservationsCurrentPage', this.$store.state.laxit.unroutedReservations.currentPage + 1)
      this.getList()
    },
    addMapOnlyData (rsvp) {
      rsvp.legs[0] = {...rsvp.legs[0], mapOnly: false}
      rsvp.legs[1] = {...rsvp.legs[1], mapOnly: false}
      return rsvp
    }
  },
  mounted () {
    let self = this
    self.$store.commit('laxit/resetUnroutedReservationsList')
    self.getList()
  }
}
</script>

<style lang="scss" scoped>
table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    border-right: none;
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
    &.psc{ background: #de6c2a; }
  }
  .status{ text-transform: capitalize; }
  .expired{ color: #de2929; }
  .fa-check-circle{ color: #0fda4e; }
  .fa-times-circle{ color: #ef3535; }
  a{ cursor: pointer; }
  .date{ word-spacing: 5px; }
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/UnroutedReservations.vue